export const getAnimationClass = (isVisible, isFadingOut = false) => {
  if (isFadingOut) return 'animate-fade-out';
  if (isVisible) return 'animate-fade-in';
  return 'hidden-initial';
};